<div *ngIf="alreadyLoggedin" class="playlist-details-wrapper">
  <div class="column-left bg-s0">
    <!-- <div [ngClass]="{'oam-nav-container': currentOam != undefined && showLanguageSwitchBtn}">
      <div [ngClass]="{'item-left': currentOam != undefined && showLanguageSwitchBtn, 'nav-container': currentOam == undefined || !showLanguageSwitchBtn}">
        <app-breadcrump-nav [data]="playlist_nav" [locale]="locale" (onClickNav)="goToNavItem($event)"></app-breadcrump-nav>
      </div>
      <div *ngIf="currentOam != undefined && showLanguageSwitchBtn" class="item-right">
        <app-language-switch-button [switchButtons]="switchButtons" [localeName]="localeName" (onClick)="changeLocale($event)"></app-language-switch-button>
      </div>
    </div> -->
    <app-play-view-loading *ngIf="currentOam == undefined" [width]="'100%'" [height]="'650px'" [blockColor]="'#FBF7EC'" [locale]="locale"></app-play-view-loading>
    <app-oam-view *ngIf="currentOam != undefined" [oamData]="currentOam" [locale]="locale" [navData]="playlist_nav" [showLanguageSwitchBtn]="showLanguageSwitchBtn" [switchButtons]="switchButtons" [localeName]="localeName" [oamSrcParams]="oamSrcParams" (onClickNavItem)="goToNavItem($event)" (onClickLanguageBtn)="changeLocale($event)"></app-oam-view>
    <div class="oam-view-pc">
      <app-oam-view-data *ngIf="currentOam != undefined" [oamData]="currentOam" [locale]="locale"></app-oam-view-data>
    </div>
    <div class="related-skills-view">
      <app-playlist-related-skills [loading]="loadingSkill" [relatedSkills]="playlistDetails?.relatedSkills" [locale]="locale" (onClickRelatedSkill)="goToSkillDetails($event)"></app-playlist-related-skills>
    </div>
  </div>
  <div class="column-right">
    <app-playlist-collection [loading]="loadingPlay" [playlist]="playlistCollection" [locale]="locale" (playOam)="playOamFromPlaylist($event)"></app-playlist-collection>
    <div class="oam-view-ipad">
      <app-oam-view-data *ngIf="currentOam != undefined" [oamData]="currentOam" [locale]="locale"></app-oam-view-data>
    </div>
    <app-related-playlist-collection [loading]="loadinglf" [relatedLearningFlow]="playlistDetails?.relatedLearningFlow" [locale]="locale" (onClickPlaylist)="onSelectPlaylist($event)"></app-related-playlist-collection>
  </div>
</div>
